import './highlight.css'

function Highlight(props) {
    return (
        <span className='highlight-text'>{props.children}</span>
    )
}

export default Highlight;